import dayjs from 'dayjs';

export enum ParkingVehicleType {
  CAR = 1,
  BIKE = 2,
  BOTH = 3,
}

export enum VehicleWheelCount {
  CAR = 4,
  BIKE = 2,
}

export enum SiteBookingType {
  NON_BOOKABLE = 0,
  BOOKABLE = 1,
  PAY_AT_SITE = 2,
}

export enum BookingStatus {
  CREATED = 'CREATED',
  PAID = 'PAID',
  CHECKED_IN = 'CHECKED_IN',
  CHECKED_OUT = 'CHECKED_OUT',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}


export type ExtraOffers = {
  url:string;
    webUrl:string;
    screenId:number;
    maxHeight:number;
    maxWidth:number;
}

export interface CompanyVehicle {
  companyId: number;
  name: string;
  vehicleList: ProjectVehicle[];
}

export interface ProjectVehicle {
  vehicleType: string;
  totalSlots: number;
  fcfsSlots: number;
  reservedSlots: number;
  fcfsOccupied: number;
  reservedOccupied: number;
  totalOccupied: number;
  fcfsVacant: number;
  reservedVacant: number;
  totalVacant: number;
}



export interface VehicleTagInfo {
  brand?: string;
  model?: string;
  brandLogo?: string;
  tagId: string;
  tagInfraId: string;
  vehicleId: any;
  vehicleNumber: any;
  vehicleType: any;
  wheelCount: number;
}

export const ParkingCategoryId = '15';
export interface ParkingType {
  id: string;
  arrivalStartTime: string;
  arrivalEndTime: string;
  corporateCtaTitle: string;
  corporateBookableMessage: string;
  corporateNonBookableMessage: string;
  totalSlots: string;
  categoryId: string;
  subCategoryId: string;
  companyId: string;
  companyName: string;
  title: string;
  bookingType: number;
  slug: string;
  address: string;
  isFullDayParking: boolean;
  city: string;
  citySlug: string;
  projectNameSlug: string;
  badgeText? :string;
  pinCode: string;
  rating: number;
  distanceFromSource: number;
  ratingCount: number;
  bookingCount: any;
  latitude: number;
  longitude: number;
  isSaved: boolean;
  isCorporate: boolean;
  isCancellable: boolean;
  isExtendable: boolean;
  isParkingBookable: boolean;
  isBookingAllowed: boolean;
  isParkplusProject: boolean;
  directionUrl: string;
  shareUrl: string;
  errorMessage: string;
  displayBasePrice: any;
  twoWheelerPrice?: number;
  fourWheelerPrice?: number;
  siteDisclaimer: string;
  images: { default: boolean; url: string }[];
  vehicleType: ParkingVehicleType;
  highlights: {
    name: string;
    icon: string;
  }[];
  timesBooked: number;
  parkingInfoText: string;
  shortUrl: string;
  isMultiDaysBookingAllowed: boolean;
  payAtSiteEnable: boolean;
  payAtSiteBookingAllowed: boolean;
  parkingInfoImage: string;
  amenitiesMetadata: {
    id: string;
    displayText: string;
    url: string;
  }[];
  nonBookableMessageLong: string;
  disclaimerText: string;
  paymentMode: string;
  nonBookableSiteSubtitle: string;
  nonBookableSiteTitle: string;
  uniqueId: string;
  vehicleTagInfo: VehicleTagInfo;
  vehicleSlots: {
    car: number;
    bike: number;
  };
}
export interface ScheduleData {
  dateTime: dayjs.Dayjs;
  count: number;
  countType: 'day' | 'hour';
}

export interface MyBookingType {
  bookingId: number;
  displayAddress: string;
  displayAmount: string;
  displayIcon: string;
  displayLocation: string;
  displayStatusIcon: string;
  displayStatusText: string;
  displayTimestamp: string;
  paymentMethod: string;
  upcoming: boolean;
  orderId: number;
  vehicleDetails: {
    vehicleLogo: string;
    vehicleNumber: string;
    vehicleBrand: string;
    vehicleModel: string;
  };
  navigationUrl: string;
  locationId: any;
  projectId: any;
  rating: any;
  ratingText: string;
}

export interface LocObjType {
  hasLocation: boolean;
  activeLocType: string;
  searchLoc: {
    coords: {
      lat: number;
      lng: number;
    };
    formattedAddress: string;
  };
  deviceLoc: {
    status: string;
    coords: {
      lat: number;
      lng: number;
    };
    formattedAddress: string;
  };
}

export interface ParkingDetailModal {
  isOpen: boolean;
  selectedSite: ParkingType;
}

export interface MyBookingModal {
  isOpen: boolean;
}

export interface ParkingReducerType {
  selectedVehicleType: ParkingVehicleType;
  parkingLocation: LocObjType;
  availableParkingLocations: ParkingType[];
  parkingDetailModal: ParkingDetailModal;
  myBookingModal: MyBookingModal;
}

export interface BookingType {
  id: string;
  locationName: string;
  brandIcon: string;
  vehicleBrand: string;
  vehicleModel: string;
  license: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  totalCost: number;
  isExtendable: boolean;
  isCorporate: boolean;
  locationId: number;
  status: string;
  qrCode: string;
  carImage: string;
  bookingPin: string;
  bookingTimeLeft: number;
  navigationUrl: string;
  paymentMethod: string;
  totalAmountCalculated: string;
  rateParking: number;
  shortUrl: string;
  paymentStatus?: string;
  isCancellable:boolean;
}

export type FeatureCardType = {
  image: string;
  backgroundColor: string;
  backgroundImage: string;
  title: string;
  subtitle: string;
};

export type BenefitCardType = {
  image: string;
  title: string;
};


export type MahaKumbhProject = {
  projectId: number;
  projectName: string;
  latitude: string; // Assuming latitude and longitude are strings in the input
  longitude: string;
  uuid: string;
  localServerUuid: string;
  vrn: string;
  wheelCount: number;
  tagId: string;
  category: string;
  entryTime: string;
  exitTime: string
  isPaid: boolean;
  userVehicleImage: {
    url: string;
    parkedLocation: {
      latitude: string; // Assuming these are strings as in the input
      longitude: string;
    };
  };
};